import * as ActionTypes from '../actions/ActionTypes';

const initialState = {
    conferenceCallInvitation: null,
    conferenceData: {},
    roomConferences: {},
    conferenceSettings: {
        maxConferenceMinutes: 90,
    },
};

export default function conference(state = initialState, action) {
    switch (action.type) {
        case ActionTypes.SET_CONFERENCE_CALL_INVITATION:
            return { ...state, conferenceCallInvitation: action.payload };
        case ActionTypes.CLEAR_CONFERENCE_CALL_INVITATION:
            return { ...state, conferenceCallInvitation: null };
        case ActionTypes.SET_CONFERENCE_DATA:
            return {
                ...state,
                conferenceData: { ...action.payload, window: state.conferenceData?.window || action.payload.window },
            };
        case ActionTypes.SET_ROOM_CONFERENCES:
            if (!action.payload.roomId) {
                return state;
            }
            return {
                ...state,
                roomConferences: {
                    ...state.roomConferences,
                    [action.payload.roomId]: {
                        ...state.roomConferences[action.payload.roomId],
                        ...action.payload,
                    },
                },
            };

        case ActionTypes.START_ROOM_CONFERENCE:
            if (!action.payload.roomId) {
                return state;
            }
            const roomConference = state.roomConferences[action.payload.roomId];

            if (roomConference?.conferenceId && roomConference.conferenceId !== 'false') {
                if (roomConference?.window && !roomConference?.window?.closed) {
                    roomConference.window.focus();
                    return state;
                } else {
                    const newRoomWindow = window.open(`/meet/${roomConference.conferenceId}`);
                    return {
                        ...state,
                        roomConferences: {
                            ...state.roomConferences,
                            [action.payload.roomId]: {
                                ...roomConference,
                                window: newRoomWindow,
                            },
                        },
                    };
                }
            }
            return state;

        case ActionTypes.START_CONFERENCE:
            let conferenceData = state.conferenceData;
            if (!conferenceData || !conferenceData?.conferenceId || conferenceData?.conferenceId === 'false') {
                const firstValidConference = Object.values(state.roomConferences || {}).find(
                    (item) => item?.conferenceId && item.conferenceId !== 'false'
                );
                conferenceData = firstValidConference;
            }
            if (!conferenceData || !conferenceData?.conferenceId || conferenceData?.conferenceId === 'false') {
                return state;
            }
            if (conferenceData.window && !conferenceData.window.closed) {
                conferenceData.window.focus();
                return state;
            }
            const newWindow = window.open(`/meet/${conferenceData.conferenceId}`);
            return {
                ...state,
                conferenceData: {
                    ...state.conferenceData,
                    window: newWindow,
                },
            };
        default:
            return state;
    }
}
